export default "__VITE_ASSET__BoMVm_uq__"